var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.loading)?_c('v-main',[(_vm.$route.path !== '/login' && !_vm.$route.path.includes('/classes/manage/dictation/single/show'))?_c('navbar',{attrs:{"notifications":_vm.notifications}}):_vm._e(),_c('global-snack-bar',{staticClass:"snackbar-text"}),_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }